// extracted by mini-css-extract-plugin
module.exports = {"tags":"_27bXiZ","tag":"_3DsDZm","shine-lines":"_3JqaBy"};